module.exports = __webpack_public_path__ + "img/image-next.4020e8a5.png";